<div class="w-full flex flex-col gap-3">
  <div class="flex items-center gap-0.5">
    <ui-skeleton class="block flex-none rounded-full w-5 h-5" />
    <ui-skeleton class="block rounded-full h-3 w-[372px]" />
  </div>
  <app-energy-interface-list-skeleton />
</div>
